import { render, staticRenderFns } from "./ShippoAddressName.vue?vue&type=template&id=0a747a20&"
import script from "./ShippoAddressName.vue?vue&type=script&lang=ts&"
export * from "./ShippoAddressName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports